import { createToggle } from "../templates/text-truncate";

const items = document.querySelectorAll(".js-truncate");

items.forEach(item => {
    const paragraphs = item.querySelectorAll("p");

    if (paragraphs.length > 1) {
        item.appendChild(createToggle());

        const toggle = item.querySelector(".js-truncate-toggle");

        if (toggle) {
            toggle.addEventListener("click", () => {
                item.classList.toggle("show");
            });
        }
    }
});